import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Paper,
  Switch,
  TextField,
  Typography,
  FormControlLabel,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import QdeliveryApi, {
  GetImpersonationRes,
} from '../../services/api/qdelivery/qdeliveryapi';
import connectQ from '../../assets/connect.png';

function QDeliveryTokenPage() {
  const [automaticCourier, setAutomaticCourier] = useState(true);
  const [orderPulling, setOrderPulling] = useState(true);
  const [automaticAssignment, setAutomaticAssignment] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState<GetImpersonationRes | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleActivateToken = () => {
    setShowSettings(true);
  };

  const handleOpenModal = async () => {
    setOpenModal(true);
    setLoading(true);
    try {
      const response = await QdeliveryApi.getImpersonation();
      setData(response.data);
    } catch (err) {
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // if (loading) {
  //   return <div>Loading...</div>;
  // }
  //
  // if (error) {
  //   return <div>{error}</div>;
  // }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          marginBottom: '32px',
        }}
      >
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: '50%',
            backgroundColor: '#E0F7FA',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5" color="primary">
            <img
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
              src={connectQ}
              alt=""
            />
          </Typography>
        </Box>
        <Typography variant="h6" ml={2}>
          Online Sipariş & Teslimat
        </Typography>
      </Paper>

      <Paper elevation={3} sx={{ p: 4, marginBottom: '32px' }}>
        <>
          <Typography variant="h6" gutterBottom>
            Platform Entegrasyonları
          </Typography>
          <TextField
            label="Yemek Sepeti Go, Getir, Trendyol Gb."
            placeholder="Yemek Sepeti Go, Getir, Trendyol Gb."
            variant="outlined"
            disabled
            fullWidth
            sx={{ mb: 4 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    onClick={handleOpenModal}
                    variant="contained"
                    color="success"
                  >
                    Bağlan
                  </Button>
                </InputAdornment>
              ),
            }}
          />
          <Typography variant="h6" gutterBottom>
            Kurye / Sipariş Yöntemi
          </Typography>
          <Typography sx={{ color: 'grey' }} gutterBottom>
            Kurye / Sipariş yönetimi QDelivery entegrasyonu Kuik.Rest için
            varsayılan olarak etkinleştirilmiştir. Bu ayarlar kullanıcı
            tarafından görüntülenebilir, ancak değiştirilemez.
          </Typography>
          <Box sx={{ display: 'grid' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={automaticCourier}
                  onChange={() => setAutomaticCourier(!automaticCourier)}
                  color="success"
                  disabled
                />
              }
              label="Otomatik Kurye Oluşturma"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={orderPulling}
                  onChange={() => setOrderPulling(!orderPulling)}
                  color="success"
                  disabled
                />
              }
              label="Sipariş Çekme / İletme"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={automaticAssignment}
                  disabled
                  onChange={() => setAutomaticAssignment(!automaticAssignment)}
                  color="default"
                />
              }
              label="Otomatik Atama - Çok Yakında!"
            />
          </Box>
        </>
      </Paper>
      <Button
        variant="contained"
        sx={{ display: 'flex', marginLeft: 'auto', backgroundColor: '#50cd89' }}
      >
        Kaydet
      </Button>
      <Dialog open={openModal} onClose={handleCloseModal} fullScreen>
        <DialogTitle
          sx={{
            backgroundColor: 'black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ color: 'white' }}>QConnect</Typography>
          <Button
            variant="contained"
            color="success"
            onClick={handleCloseModal}
          >
            Geri Dön
          </Button>
        </DialogTitle>
        <DialogContent sx={{ margin: '0px', padding: '0px' }}>
          {data ? (
            <iframe
              src={`${process.env.REACT_APP_QDELIVERY_LINK}=${data.session_id}`}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title="Uygulamalar"
            />
          ) : null}
        </DialogContent>
      </Dialog>
    </Container>
  );
}

export default QDeliveryTokenPage;
